import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class ApiKey extends NousCoreModel {
	key = "";
	enabled = false;
	__selected = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();

		exportData.enabled = this.exportBooleanField("enabled");

		return exportData;
	}

	import (data, options) {
		this.__import(data, options);

		this.importBooleanField("enabled", data.enabled);
	}
}

Shark.registerModel("ApiKey", ApiKey);

export default ApiKey;